/** @jsxImportSource @emotion/react */
import {
  Button,
  Loader,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { QRCodeCanvas } from 'qrcode.react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useCreateAuthenticatorSetupUrl } from '../../api/authenticatorApi';

export const MfaAuth = () => {
  const navigate = useNavigate();
  const { spacing } = useTheme();
  const { data: authenticatorSetupUrl, error } =
    useCreateAuthenticatorSetupUrl();

  if (error) return <Navigate to="/settings/security" />;
  if (!authenticatorSetupUrl) return <Loader />;

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: spacing.m,
        textAlign: 'center',
      }}
    >
      <div css={{ marginBottom: spacing.m }}>
        <Typography variant="heading2">Two-factor authentication</Typography>
      </div>
      <Typography variant="body">
        Open the two-factor authenticator app and scan this QR code
      </Typography>
      <QRCodeCanvas
        size={200}
        value={authenticatorSetupUrl.url}
        css={{ marginTop: spacing.m, marginBottom: spacing.m }}
      />
      <Typography variant="bodySmallBold">Don&apos;t have the app?</Typography>
      <Typography variant="bodySmall">
        Google authenticator is free. Download it on your mobile device by
        searching for &quot;Google authenticator&quot; on the{' '}
        <a
          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Play Store
        </a>{' '}
        or{' '}
        <a
          href="https://apps.apple.com/app/google-authenticator/id388497605"
          target="_blank"
          rel="noopener noreferrer"
        >
          App Store
        </a>
        .
      </Typography>

      <div css={{ display: 'inline-block', marginTop: spacing.xs }}>
        <Button text="Next" onClick={() => navigate('verify')} />
      </div>
    </div>
  );
};
